export const BRAND_ATTRIBUTE = 'data-brand'
export const QCS_BRAND = 'qcs'

export const QCS_PALETTE = {
  primary: '#0F3D3C',
  primaryRgb: '15, 61, 60',
  primaryHover: '#155150',
  primaryLight: '#E4EFED',
  navBg: '#0F3D3C',
  navBg2: '#0F3D3C',
  navActive: '#17514F',
  navItemInactive: 'rgba(255, 255, 255, 0.88)',
  navItemActiveBg: 'rgba(255, 255, 255, 0.14)',
  bg: '#F4F6F5',
  rowDefault: '#FAFBFA',
  rowAlt: '#EEF3F2',
  border: '#DCE4E2',
  divider: '#E8ECEB',
  statusInactive: '#B77714',
  statusInactiveLight: '#FBF1E1',
  error: '#C1431C',
  errorLight: '#FBEAE4',
  success: '#2F7D32',
  successLight: '#E6F2E6',
}

export const applyBrandTheme = isQcs => {
  const root = typeof document !== 'undefined' && document.documentElement
  if (!root) return

  if (isQcs) {
    root.setAttribute(BRAND_ATTRIBUTE, QCS_BRAND)
  } else {
    root.removeAttribute(BRAND_ATTRIBUTE)
  }
}
